
// This is an auto generated file - do not edit!
// Swagger path: /api/DocumentRequirement/bulkaction/{actionCode}

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';

import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class DocumentrequirementBulkactionActioncodeApiService extends BaseApiService {
    
    patch(actionCode: string, body: any[], code?: string, options = {}): Observable<any> {
        let params = new HttpParams();
        if(code !== undefined) {
            params = params.append('code', code);
        }

        return this._patch<any, any[]>(
            `/DocumentRequirement/bulkaction/${actionCode}`,
            body, {
                ...options,
                params,
            }
        );
    }
}
